import { actionTypes as resourceActions } from 'redux-resource';
import * as types from './types';

export const find = (id) => ({
  type: types.FIND,
  payload: { id }
});

export const fetchAll = (userId) => ({
  type: types.FETCH_ALL,
  payload: { userId }
});

export const updatePlan = (id, planId) => ({
  type: types.UPDATE_PLAN,
  payload: { id, planId }
});

export const update = (id, fields) => ({
  type: types.UPDATE,
  payload: { id, fields }
});

export const setUpcomingPlan = (id, plan) => ({
  type: resourceActions.UPDATE_RESOURCES,
  meta: {
    bypassedSubscriptions: {
      [id]: {
        upcomingPlan: plan
      }
    }
  }
});

export const setInsuredDevice = (id, insuredDeviceId) => ({
  type: resourceActions.UPDATE_RESOURCES,
  meta: {
    bypassedSubscriptions: {
      [id]: {
        insuredDeviceId
      }
    }
  }
});

export const setInsuranceContract = (id, insuranceContractId) => ({
  type: resourceActions.UPDATE_RESOURCES,
  meta: {
    bypassedSubscriptions: {
      [id]: {
        insuranceContractId
      }
    }
  }
});

export const setUpgradePurchase = (id, purchase) => ({
  type: resourceActions.UPDATE_RESOURCES,
  meta: {
    bypassedSubscriptions: {
      [id]: {
        upgradePurchase: purchase
      }
    }
  }
})
